import { render } from "./TheLeftMenu.vue?vue&type=template&id=7c8dd24e"
import script from "./TheLeftMenu.vue?vue&type=script&lang=js"
export * from "./TheLeftMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__